import axios from 'axios'
import { REMARCAR_RESERVA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function remarcarReservas (reservas) {
  const url = `${URL}/reserva/remarcar-reservas`;
  return dispatch => axios.post(url, reservas, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: REMARCAR_RESERVA,
        payload: response
      })
  );
}
